import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form, FormInstance } from 'antd';
import ConditionRulesBuilder from '@components/configure-network-panel/components/ConditionBuilder/ConditionRulesBuilder';
import { INETWORK_CONFIGURES } from '@api/emp/types';

const initConfigureNetworkRequestData = {
  name: '',
  configuration: {
    target_url: [''],
    request_header: [''],
    request_payload: [''],
    response_header: [''],
    response_body: [''],
  },
};

const urlConditionOptions = [
  { label: 'All', value: 'All' },
  { label: 'Contains...', value: 'Contains...' },
];

interface NetworkConfigEditProps {
  data?: INETWORK_CONFIGURES;
  isNew?: boolean;
  onFormChange?: (form: FormInstance, allValues: Record<string, unknown>) => void;
  formRef?: (form: FormInstance) => void;
  onUrlConditionChange?: (value: string) => void;
}

const NetworkConfigEdit: React.FC<NetworkConfigEditProps> = ({
  data,
  isNew = false,
  onFormChange,
  formRef,
  onUrlConditionChange,
}) => {
  const [form] = Form.useForm();
  const [urlConditionValue, setUrlConditionValue] = useState<string>(urlConditionOptions[1].value);
  const [highlightRequiredText, setHighlightRequiredText] = useState<boolean>(false);

  useEffect(() => {
    if (formRef) {
      formRef(form);
    }
  }, [form, formRef]);

  useEffect(() => {
    if (data && !isNew) {
      form.setFieldsValue({
        name: data.name || '',
        configuration: {
          ...initConfigureNetworkRequestData.configuration,
          ...data.configuration,
        },
      });
      if (!data.configuration?.target_url) {
        setUrlConditionValue(urlConditionOptions[0].value);
      } else {
        setUrlConditionValue(urlConditionOptions[1].value);
      }
    } else {
      form.resetFields();
      form.setFieldsValue(initConfigureNetworkRequestData);
      setUrlConditionValue(urlConditionOptions[1].value);
    }
  }, [data, isNew, form]);

  const handleSelectChange = useCallback(
    (value: string) => {
      setUrlConditionValue(value);
      onUrlConditionChange?.(value);
    },
    [onUrlConditionChange],
  );

  const handleFormChange = useCallback(
    (_: unknown, allValues: Record<string, unknown>) => {
      onFormChange?.(form, allValues);
    },
    [form, onFormChange],
  );

  return (
    <div style={{ padding: '0 12px' }}>
      <ConditionRulesBuilder
        mode="edit"
        highlightRequiredText={highlightRequiredText}
        selectValue={urlConditionValue}
        options={urlConditionOptions}
        onSelectChange={handleSelectChange}
        form={form}
        onFormChange={handleFormChange}
        initialValues={initConfigureNetworkRequestData}
        hideConfigName
      />
    </div>
  );
};

export default NetworkConfigEdit;
